// src/App.js
import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import HomePage from './HomePage';
import WeStudyDigital from './WeStudyDigital';
import TablePage from './TablePage'
import TimerPage from './timer';
import BuvetteMenu from './BuvetteMenu';
import LoyaltyClaimPage from './LoyaltyClaimPage';
import PowerbankCheckout from './powerbank'
import ListeDAttente from './waitlist';
import PomodoroSetup from './PomodoroSetup';
import ECNInscription from "./ECNInscription";

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/digital" element={<WeStudyDigital />} />
                <Route path="/ECN" element={<ECNInscription />} />

        <Route path="/table/:id" element={<TablePage />} />
        <Route path="/timer/:id" element={<TimerPage />} />
        <Route path="/setup/table/:id" element={<PomodoroSetup />} />
                <Route path="/liste" element={<ListeDAttente />} />
  <Route path="/loyalty" element={<LoyaltyClaimPage />} />
<Route path="/menu" element={<BuvetteMenu />} />
<Route path="/powerbank/:powerbankNumber" element={<PowerbankCheckout />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
